import axios from 'axios';
export default class MyApi {
    /*

    */
    constructor(bucket, fileName) {
        this.bucket = bucket;
        this.fileName = fileName;
    }

    async requestApi(type, data) {
        let baseUrl = "https://e91q1mz7e1.execute-api.cn-northwest-1.amazonaws.com.cn/"
        let result = ''
        await axios({
            //list get create update remove,
            url: baseUrl + type,
            method: 'post',
            data: data,
            timeout: 60000
        }).then((v) => {
            result = v.data
            // console.log(v.data);
        }).catch((err) => {
            console.log('api请求报错==>>', err.message, err.response?.data)
        });
        return result
    }

    async getAllInfo() {
        return await this.requestApi('allJson', { bucketName: this.bucket })
    }
    async getInfo() {
        return await this.requestApi('get', { bucketName: this.bucket, jsonName: this.fileName })
    }

    async updateInfo(obj) {
        // console.log(obj);
        let res = await this.requestApi('update', { bucketName: this.bucket, jsonName: this.fileName, body: obj })
        if (res?.message && res?.message === `JSON file '${this.fileName}' updated`) return true
        else {
            console.log(res);
            return false
        }
    }

    async removeInfo() {
        let res = await this.requestApi('remove ', { bucketName: this.bucket, jsonName: this.fileName })
        if (res?.message && res?.message === `JSON file '${this.fileName}' deleted`) return true
        else {
            console.log(res);
            return false
        }
    }
    async createInfo(obj) {
        let res = await this.requestApi('create', { bucketName: this.bucket, jsonName: this.fileName, body: obj })
        if (res?.message && res?.message === 'JSON saved to S3') return true
        else {
            console.log(res);
            return false
        }
    }
}